import React, { Component } from "react";
import { withAuth } from "../../../shared/containers/containerAuth";
import { withCompanies } from "../../../shared/containers/containerCompanies";
import LoginIcon from "@mui/icons-material/Login";
import styles from "./cmsCompanyEnteriing.module.scss";
import { states } from "../../../reducers/queriesStates";

class CmsCompanyEntering extends Component {
  onClickHandler() {
    const { onEnteringCompany, company } = this.props;

    onEnteringCompany(company);
  }

  render() {
    const { data } = this.props;

    if (!data.permissions.includes(10006)) {
      return null;
    }

    return (
      <div className={styles.container} onClick={this.onClickHandler.bind(this)}>
        <span > Вход как пользователь компании </span>
        <LoginIcon fontSize="small" />
      </div>
    );
  }
}

export default withCompanies(withAuth(CmsCompanyEntering));
